import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';

class ReportCollectModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportCollectModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            ReportsModel,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ChangePaymentType,
            ChangeActiveAmount,
            ChangeCondition,
            ChangeAmount,
            GenerateReportCollect,
            AvailablePayments,
            ShowPDFViewerModal,
            ListReports,
            ShowPDFViewer,
            MailTools,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
        } = this.props;
        // AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));

        return (
            <div className="modal fade" id="reportCollectModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportCollectModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Cobranza</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">
                                <div className='row'>
                                    <div className='col-12 col-md-12'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Forma de pago:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                style={{
                                                    color: "#000",
                                                    borderRadius: 4,
                                                    backgroundColor: "transparent",
                                                    height: 40
                                                }}
                                                value={ReportsModel.PaymentType}
                                                onChange={event => ChangePaymentType(event)}
                                            >
                                                <option value="---">Seleccionar</option>
                                                {!!AvailablePayments && AvailablePayments.map(payment => {

                                                    return (
                                                        <option value={payment.idPMBO}>{`${payment.name}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>

                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-lg-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="flexCheckDefault"
                                                        checked={ReportsModel.checkActiveAmount}
                                                        onClick={ChangeActiveAmount} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="flexCheckDefault"> Activar filtro de montos </label>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Monto:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                disabled={!ReportsModel.checkActiveAmount}
                                                value={ReportsModel.Condition}
                                                onChange={event => ChangeCondition(event)}
                                            >
                                                <option className="text-center" value="<" style={{ fontWeight: "bold" }}>{"<"}</option>
                                                <option className="text-center" value=">" style={{ fontWeight: "bold" }}>{">"}</option>
                                                <option className="text-center" value="=" style={{ fontWeight: "bold" }}>{"="}</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={!ReportsModel.checkActiveAmount}
                                                value={ReportsModel.Amount}
                                                onChange={(event) => ChangeAmount(event)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-8'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReportCollect()}>Generar</button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        ActualDate={ActualDate}
                        TypeDoc={'ReportCollect'}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={'SalesTools.EditableDocModel'}
                        RefreshDocModel={'SalesTools.RefreshDocModel'}
                        SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                        UploadDoc={'SalesTools.UploadInvoice'}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={'user'}
                        Counter={true}
                        ReportsModel={ReportsModel}
                        MailTools={MailTools}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }
            </div>
        );
    }
}

export default ReportCollectModal;